import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { BusinessGuard } from './core/guards/business.guard';
import { PermissionGuard } from './core/guards/permission.guard';
import { NavigationRouteGuard } from './core/guards/navigation-route.guard';
import { AgriSupplyGuard } from './core/guards/agri-supply.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./modules/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'select-business',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./modules/business-selector/business-selector.component').then(m => m.BusinessSelectorComponent)
  },
  {
    path: '',
    canActivate: [AuthGuard, BusinessGuard],
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'DASHBOARD' }
      },
      {
        path: 'companies',
        loadComponent: () => import('./modules/companies/companies.component').then(m => m.CompaniesComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'COMPANIES' }
      },
      {
        path: 'products',
        loadComponent: () => import('./modules/products/products.component').then(m => m.ProductsComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'PRODUCTS' }
      },
      {
        path: 'recipes',
        loadComponent: () => import('./modules/recipes/recipes.component').then(m => m.RecipesComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'RECIPES' }
      },
      {
        path: 'orders',
        loadComponent: () => import('./modules/orders/orders.component').then(m => m.OrdersComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'ORDERS' }
      },
      {
        path: 'customers',
        loadComponent: () => import('./modules/customers/customers.component').then(m => m.CustomersComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'CUSTOMERS' }
      },
      {
        path: 'catalogs',
        loadComponent: () => import('./modules/catalogs/catalogs.component').then(m => m.CatalogsComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'CATALOGS' }
      },
      {
        path: 'collections',
        loadComponent: () => import('./modules/collections/collections.component').then(m => m.CollectionsComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'COLLECTIONS' }
      },
      {
        path: 'brands',
        loadComponent: () => import('./modules/brands/brands.component').then(m => m.BrandsComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard, AgriSupplyGuard],
        data: { permission: 'BRAND' }
      },
      {
        path: 'scheduler',
        loadComponent: () => import('./modules/scheduler/scheduler.component').then(m => m.SchedulerComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'SCHEDULER' }
      },
      {
        path: 'kalio-products',
        loadComponent: () => import('./modules/kalio-products/kalio-products.component').then(m => m.KalioProductsComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'KALIO_PRODUCTS' }
      },
      {
        path: 'kalio-management/kalio-products',
        redirectTo: 'kalio-products',
        pathMatch: 'full'
      },
      {
        path: 'users',
        loadComponent: () => import('./modules/users/users.component').then(m => m.UsersComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'USER_MANAGEMENT' }
      },
      {
        path: 'documentation',
        loadComponent: () => import('./modules/documentation/documentation.component').then(m => m.DocumentationComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'DOCUMENTATION' }
      },
      {
        path: 'general-settings',
        loadComponent: () => import('./modules/general-settings/general-settings.component').then(m => m.GeneralSettingsComponent),
        canActivate: [PermissionGuard, NavigationRouteGuard],
        data: { permission: 'GENERAL_SETTINGS' }
      },
      {
        path: 'logs',
        loadComponent: () => import('./modules/logs/logs.component').then(m => m.LogsComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
